import React, {useState} from "react";
import ReactTable from "react-table-v6"
import { ArrowForward } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import { AddCircle } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import 'react-table-v6/react-table.css'

const SiteList = (props) => {
    let history = useHistory();

    if (!props.sites)  return null;
    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            style: {paddingTop: 15}
        },
/*         {
            Header: 'Enrollment',
            accessor: 'enrollment',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value && p.value > 0 ? p.value : null
            },
        }, */
        {
            Header: 'District',
            accessor: 'district',
            style: {paddingTop: 15},
        },
        {
            Header: 'City',
            accessor: 'city',
            style: {paddingTop: 15},
        },
        {
            Header: 'State',
            accessor: 'state',
            style: {paddingTop: 15},
        },
        {
            Header: 'Climate Zone',
            accessor: 'climate_zone',
            style: {paddingTop: 15},
        },

        /*
        {
            Header: 'Area',
            accessor: 'area',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value ? p.value + " sqft" : null
            },
        },
         {
            Header: 'Default Height',
            accessor: 'floor_to_ceiling_height',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value ? p.value + " ft" : null
            },
        }, */
        {
            Header: '',
            accessor: 'site_id',
            Cell: p => {
                let link = "/locations/" + p.value

                return <IconButton 
                            variant="contained" 
                            color="primary"
                            aria-label={"View site detail" }
                            size={"small"}
                            onClick={() => {
                                        history.push(link)
                                }}>
                            <ArrowForward />
                        </IconButton>
            },
            width: 50
        },
    ]
         
        return (
            <div className="site-list">
                <div className="site-add-mode">  
                    <Tooltip title="Add a New Site">   
                        <IconButton 
                                variant="contained" 
                                color="primary"
                                aria-label={"View and edit site settings" }

                                onClick={() => {
                                    history.push("/locations/add")
                            }}>
                                    <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.1)"}}/>
                        </IconButton>
                    </Tooltip>
                </div> 
                <div className="section-header">Sites </div>
                <div className="point-list-table">
                    <ReactTable key={(props.sites && props.sites.length) || 0}
                        data={props.sites || []}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={10}
                        showPagination={props.sites && props.sites.length > 10}
                    />
                </div>
            </div>
        )
}

export default SiteList;
